<template>
  <div class="container-fluid">
    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <!-- HR 人員 -->
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">HR 人員</label>
              <el-select
                class="w-100"
                filterable
                clearable
                multiple
                value-key="Guid"
                collapse-tags
                placeholder="請選擇"
                v-model="searchCondition.HRUserGuids"
              >
                <el-option
                  v-for="supervisor in supervisorOptions"
                  :key="supervisor.Guid"
                  :label="supervisor.Name"
                  :value="supervisor.Guid"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- 轉入時間 -->
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">轉入時間</label>
              <el-date-picker
                class="w-100"
                type="datetimerange"
                format="yyyy-MM-dd HH:mm"
                start-placeholder="開始時間"
                end-placeholder="結束時間"
                v-model="searchCondition.createTime"
              >
              </el-date-picker>
            </div>
          </div>
          <!-- 分派時間 -->
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">分派時間</label>
              <el-date-picker
                class="w-100"
                type="datetimerange"
                format="yyyy-MM-dd HH:mm"
                start-placeholder="開始時間"
                end-placeholder="結束時間"
                v-model="searchCondition.assignTime"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="col-sm-12 col-md-3">
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-left: 10px"
              @click="search"
            >
              查詢
            </button>
            <button
              v-if="$Permission.ResumeAllocation.SpecialAllocation.IsValid"
              type="button"
              class="btn btn-info"
              style="margin-top: 30px; margin-left: 10px"
              @click="openModal"
            >
              自動分派
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="yahome-table-wrap">
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column prop="Name" label="姓名" />
        <el-table-column prop="Email" label="Email" />
        <el-table-column prop="IdNo" label="身分證" />
        <el-table-column prop="MobilePhone" label="電話" />
        <el-table-column prop="Sex" label="性別" width="140" />
        <el-table-column label="HR 人員" width="280">
          <template slot-scope="props">
            <el-select
              class="w-100"
              filterable
              @change="changeAssign(props.row)"
              v-model="props.row.AssignHR"
              :disabled="!$Permission.ResumeAllocation.SpecialAllocation.IsValid"
            >
              <el-option
                v-for="supervisor in supervisorOptions"
                :key="supervisor.Guid"
                :label="supervisor.Name"
                :value="supervisor.Guid"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="分派時間">
          <template slot-scope="props">
            <span>{{ $common.dateTimeFormatter(props.row.AssignTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="轉入時間">
          <template slot-scope="props">
            <span>{{ $common.dateTimeFormatter(props.row.CreateTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="聯繫紀錄">
          <template slot-scope="props">
            <button type="button" class="btn btn-sm btn-primary" @click="showContactInfo(props.row)">聯繫紀錄</button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="totalData"
        :page-size="10"
        :current-page.sync="tableInfo.page"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

    <!-- 自動分派 Modal -->
    <div
      class="modal fade"
      id="assignModal"
      data-focus="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver ref="assign" v-slot="{ handleSubmit, reset }">
          <form @reset.prevent="reset">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">自動分派</h5>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label for=""> <span class="mark">*</span>HR 人員 </label>
                  <ValidationProvider name="HR 人員" rules="required" v-slot="{ errors }">
                    <el-select
                      class="w-100"
                      filterable
                      clearable
                      multiple
                      collapse-tags
                      placeholder="請選擇"
                      v-model="assign.HRUserGuids"
                    >
                      <el-option
                        v-for="supervisor in supervisorOptions"
                        :key="supervisor.Guid"
                        :label="supervisor.Name"
                        :value="supervisor.Guid"
                      >
                      </el-option>
                    </el-select>
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
                <div class="form-group">
                  <label for=""> <span class="mark">*</span>轉入時間 </label>
                  <ValidationProvider name="轉入時間" rules="required" v-slot="{ errors }">
                    <el-date-picker
                      class="w-100"
                      type="datetimerange"
                      format="yyyy-MM-dd HH:mm"
                      start-placeholder="開始時間"
                      end-placeholder="結束時間"
                      v-model="assign.createTime"
                    >
                    </el-date-picker>
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="reset"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  取消
                </button>
                <button
                  type="button"
                  class="btn btn-success"
                  @click="handleSubmit(autoAssign)"
                >
                  確定
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 聯絡資訊  -->
    <ContactInfoModal :personData="interviewee" />
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
// 聯繫資訊
import ContactInfoModal from "@/components/back/Modal/ContactInfo";

export default {
  name: "ResumeAllocation",

  components: {
    ContactInfoModal
  },
  data() {
    return {
      supervisorOptions: [],
      searchCondition: {},

      // table data
      tableData: [],
      totalData: 0,
      // 分頁資訊
      tableInfo: {
        page: 1,
        perPage: 10,
      },

      interviewee: {},

      assign: {},
    };
  },

  methods: {
    // 查詢
    search(resetPage = true) {
      if (resetPage) this.tableInfo.page = 1;
      this.updateLoading(true);
      this.$api.resume
        .getAssignResume({
          HRUserGuids: this.searchCondition.HRUserGuids,
          CreateTimeStart: this.searchCondition.createTime
            ? this.dayjs(this.searchCondition.createTime[0]).format(
                "YYYY-MM-DDTHH:mm"
              )
            : null,
          CreateTimeEnd: this.searchCondition.createTime
            ? this.dayjs(this.searchCondition.createTime[1]).format(
                "YYYY-MM-DDTHH:mm"
              )
            : null,
          AssignTimeStart: this.searchCondition.assignTime
            ? this.dayjs(this.searchCondition.assignTime[0]).format(
                "YYYY-MM-DDTHH:mm"
              )
            : null,
          AssignTimeEnd: this.searchCondition.assignTime
            ? this.dayjs(this.searchCondition.assignTime[1]).format(
                "YYYY-MM-DDTHH:mm"
              )
            : null,
        })
        .then((response) => {
          if (response.status === 200) {
            this.tableData = response.data;
          }
          this.updateLoading(false);
        });
    },

    // 打開自動分派 Modal
    openModal() {
      this.assign = {};
      this.$refs.assign.reset();
      $("#assignModal").modal("show");
    },

    // 聯繫資訊
    showContactInfo(person) {
      this.interviewee.ResumeId = person.Guid;
      this.$store.commit("OpenContactInfoModal", true);
    },

    // 自動分派
    autoAssign() {
      $("#assignModal").modal("hide");
      this.updateLoading(true);
      this.$api.resume
        .postAutoAssign({
          HRUserGuids: this.assign.HRUserGuids,
          CreateTimeStart: this.dayjs(this.assign.createTime[0]).format(
            "YYYY-MM-DDTHH:mm"
          ),
          CreateTimeEnd: this.dayjs(this.assign.createTime[1]).format(
            "YYYY-MM-DDTHH:mm"
          ),
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "分派成功",
              type: "success",
              duration: 3500,
            });
          }
          this.updateLoading(false);
        });
    },

    // 單一指派
    changeAssign(resume) {
      this.updateLoading(true);
      this.$api.resume
        .postAssign({
          ResumeId: resume.Guid,
          UserGuid: resume.AssignHR,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "指派成功",
              type: "success",
              duration: 3500,
            });
            this.search();
          }
          this.updateLoading(false);
        });
    },

    // el-table 分頁
    handleCurrentChange(currentPage) {
      this.tableInfo.page = currentPage;
      this.search(false);
    },

    async getData() {
      const backgroundUser = await this.$api.backgroundUser.getBackgroundUser();
      this.supervisorOptions = backgroundUser.data.map((user) => {
        return {
          Guid: user.UserId,
          Name: user.Name,
        };
      });
    },
    // loading
    ...mapActions(["updateLoading"]),
  },

  created() {
    this.getData();
  },
};
</script>
